import axios from 'axios';

const BASE_URL = 'http://202.65.119.93:34579/';

const api = axios.create({
  baseURL: BASE_URL,
  // withCredentials: true,
});

// Add token from localStorage to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
});

export default api;
